/**
 * Format a French phone number for display.
 * @param phone - The phone number to format (eg: +33601020304)
 * @returns The formatted phone number (eg: 06 01 02 03 04)
 */
export function formatPhoneNumber(phone: string): string {
  return phone.replace(/^\+33 ?/, '0').replace(/(\d{2})(?=\d)/g, '$1 ')
}
